import { Injectable } from '@angular/core';
import { Paginator } from '@app/classes';
import { AnalyticEvents } from '@app/enums';
import { ApplicantInterviews } from '@app/models/recruiting/applicant-interviews.model';
import { Interview } from '@app/models/recruiting/interview.model';
import { Table } from '@app/modules/table/classes/table.class';
import { AnalyticService } from '@app/services';
import { CompletionProgressColumn } from './columns/completion-progress.column';
import { DueDateColumn } from './columns/due-date.column';
import { InterviewersColumn } from './columns/interviewers.column';
import { NameColumn } from './columns/name.column';

const pageSize = 10;

@Injectable()
export class JobPostingApplicantInterviewsTable extends Table {
    links = true;
    trackViewEvent = true;

    constructor(
        private interview: Interview,
        private analyticService: AnalyticService
    ) {
        super();
        this.boot();
    }

    getLink(applicantInterview: ApplicantInterviews): (string | number)[] {
        // Added this to prevent angular multiple calls to the event.
        if (this.trackViewEvent) {
            this.trackViewEvent = false;
            this.analyticService.trackEvent(AnalyticEvents.RecruitngJobPostingInterviewsViewApplicantInterview);
        }

        return [
            '/recruiting',
            'jobPostings',
            this.interview.atsJobId,
            'interviews',
            'applicantInterviews',
            applicantInterview.id,
        ];
    }

    setColumns(): void {
        this.addColumns(
            new NameColumn(),
            new InterviewersColumn(),
            new DueDateColumn(),
            new CompletionProgressColumn()
        );
    }

    setDataSource(): void {
        this.paginator = new Paginator(
            ApplicantInterviews.where('atsInterviewId', this.interview.id)
                .with(['applicant', 'applicantInterviewers', 'applicantInterviewers.interviewer'])
                .limit(pageSize),
            {
                pageSize: pageSize,
            }
        );
    }
}
